export default __webpack_public_path__ + "static/media/a024-12.ce838c58.svg";